// Map of additional ingredients/additives identified by numeric index.
// Usage: import { ingredientMap } from '@/collections/zusatzstoffe';
// then lookup with ingredientMap[2] === 'Antioxidants'.

export const ingredientMap: Record<number, string> = {
    2: 'Mit Antioxidationsmittel',
    3: 'Enthält eine Phenylalaninquelle',
    4: 'Mit Farbstoff',
    5: 'Mit Süßungsmittel',
    6: 'Koffeinhaltig',
    7: 'Mit Phosphat',
    8: 'Stabilisatoren',
    11: 'Chininhaltig',
    15: 'Mit einer Zuckerart und Süßungsmittel',
    // add further ingredients as needed
};

export const allergensMap: Record<string, string> = {
    'f': 'Soja',
    'g': 'Milch und Laktose',
    'l': 'Sulfide',
    // add further ingredients as needed
};

/*
2→²  
3→³  
4→⁴  
5→⁵  
6→⁶  
7→⁷  
8→⁸  
11→¹¹  
15→¹⁵

f→ᶠ  
g→ᵍ  
l→ˡ
*/
